module.exports = __webpack_public_path__ + "static/media/blob.01899307.png";